/** Admin dashboard analytics: companies + subscriptions + payments + super admins. */
export const getAdminDashboardAnalyticsQuery = `
  query GetAdminDashboardAnalytics($input: AdminAnalyticsInput) {
    getAdminDashboardAnalytics(input: $input) {
      code
      companyAnalytics {
        totalCompanies
        activeCompanies
        registeredCompanies
        pendingCompanies
        deactivatedCompanies
        companiesRegisteredInPeriod
        companiesByStatus { key value }
        byBusinessType {
          businessType
          total
          active
          pending
          deactivated
          byCountry {
            countryCode
            total
            active
            pending
            deactivated
          }
        }
      }
      subscriptionAnalytics {
        totalSubscriptions
        activeSubscriptions
        subscriptionsCreatedInPeriod
        subscriptionsExpiringInPeriod
        subscriptionsByStatus { key value }
        byBusinessType {
          businessType
          total
          active
          byCountry {
            countryCode
            total
            active
          }
        }
      }
      paymentAnalytics {
        totalRevenue
        revenueInPeriod
        vatToPay
        vatInPeriod
        totalPaymentsCount
        mostUsedPaymentMethod
        paymentsByMethod { key value }
        paymentsByStatus { key value }
        revenueByMethod { key value }
        byBusinessType {
          businessType
          totalRevenue
          completedPayments
          byCountry {
            countryCode
            totalRevenue
            completedPayments
          }
        }
      }
      superAdminAnalytics {
        totalSuperAdmins
        superAdminsByRole { key value }
        activeSuperAdmins
        superAdminsByStatus { key value }
        superAdminsLastLoginInPeriod
        newSuperAdminsInPeriod
      }
    }
  }
`;
